// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"721":"4cc5d3bb","730":"db73e345","818":"d3ab2bf7"}[chunkId] + ".chunk.js";
};